import { BaseRouteService } from 'core/services';

class FulfillmentOrderProcessingRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-order-processing/';
	}

	createFulfillmentShipment = (id, sourceOfChange, updateAndCreatePrintJob) => {
		return this.uriTemplateService
			.parse(
				this.base +
					'create-fulfillment-shipment/{id}/?sourceOfChange={sourceOfChange}&updateAndCreatePrintJob={updateAndCreatePrintJob}'
			)
			.expand({ id, sourceOfChange, updateAndCreatePrintJob });
	};

	createFulfillmentShipmentBulk = (sourceOfChange, updateAndCreatePrintJob) => {
		return this.uriTemplateService
			.parse(
				this.base +
					'create-fulfillment-shipment-bulk/?sourceOfChange={sourceOfChange}&updateAndCreatePrintJob={updateAndCreatePrintJob}'
			)
			.expand({ sourceOfChange, updateAndCreatePrintJob });
	};

	assignCarrierServiceAndWarehouse(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'assign/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	assignCarrierServiceAndWarehouseBulk(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'assign-bulk/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	markAsShipped(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'mark-as-shipped/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	markAsShippedBulk(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'mark-as-shipped-bulk/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	changeShipping(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'change-shipping/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	changeShippingBulk(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'change-shipping-bulk/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	neverShipped(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'never-shipped/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	neverShippedBulk(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'never-shipped-bulk/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	abortLabelingMode(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'abort-labeling/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	splitFulfillmentOrderLabelingMode(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'split-fulfillment-order-labeling-mode/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}

	splitFulfillmentOrder = sourceOfChange => {
		return this.uriTemplateService
			.parse(`${this.base}split-fulfillment-order?sourceOfChange={sourceOfChange}`)
			.expand({ sourceOfChange });
	};

	editFulfillmentOrderSplit = sourceOfChange => {
		return this.uriTemplateService
			.parse(`${this.base}edit-fulfillment-order-split?sourceOfChange={sourceOfChange}`)
			.expand({ sourceOfChange });
	};

	updateFulfillmentOrderInfo(sourceOfChange) {
		return this.uriTemplateService
			.parse(this.base + 'update-fulfillment-order-info/?sourceOfChange={sourceOfChange}')
			.expand({ sourceOfChange });
	}
}

export default FulfillmentOrderProcessingRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/FulfillmentOrderProcessingRouteService.js